import { View, Text } from '@react-pdf/renderer'
import { styles } from '../styles'
import { RatingCircle } from './RatingCircle'
import { FirstPhotoRow, RemainingPhotoRows } from './PhotoGrid'

export function CategoryBlock({ code, name, comment, rating, photos }) {
  const hasContent = comment || (photos && photos.length > 0)
  const hasPhotos = photos && photos.length > 0
  const hasMorePhotos = photos && photos.length > 2

  // Empty category - minimal display
  if (!hasContent) {
    return (
      <View style={styles.categoryContainer} wrap={false}>
        <Text style={styles.categoryHeading}>{code} {name}</Text>
        <View style={styles.emptyCategoryBox}>
          <RatingCircle rating={rating || 'NI'} size={20} />
        </View>
      </View>
    )
  }

  // Category with content
  // Title stays with first section (wrap={false})
  // Remaining photos flow but overlap border to look seamless
  return (
    <View style={styles.categoryContainer}>
      {/* Title + comment + first 2 photos - MUST stay together */}
      <View wrap={false}>
        <Text style={styles.categoryHeading}>{code} {name}</Text>
        <View style={{
          ...styles.categoryBox,
          // Remove bottom border if more photos (they'll provide it)
          borderBottomWidth: hasMorePhotos ? 0 : 1,
          borderBottomLeftRadius: hasMorePhotos ? 0 : 4,
          borderBottomRightRadius: hasMorePhotos ? 0 : 4,
        }}>
          <View style={styles.categoryContent}>
            <Text style={styles.categoryDescription}>{comment || ''}</Text>
            <View style={styles.categoryRating}>
              <RatingCircle rating={rating || 'NI'} size={20} />
            </View>
          </View>

          {/* First row of photos - stays with comment */}
          {hasPhotos && (
            <FirstPhotoRow photos={photos} categoryCode={code} />
          )}
        </View>
      </View>

      {/* Remaining photos - continues the box, can flow to next page */}
      {hasMorePhotos && (
        <View style={{
          borderLeftWidth: 1,
          borderRightWidth: 1,
          borderBottomWidth: 1,
          borderTopWidth: 0,
          borderColor: '#999',
          borderBottomLeftRadius: 4,
          borderBottomRightRadius: 4,
          padding: 8,
        }}>
          <RemainingPhotoRows photos={photos} categoryCode={code} />
        </View>
      )}
    </View>
  )
}

export default CategoryBlock
